// src/admin/components/util/CustomDropdownIndicator.jsx
import { components } from "react-select";
import { FaCog } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6"; // Ícone padrão

const CustomDropdownIndicator = (props) => {
    const { selectProps, hasValue } = props;

    return (
        <components.DropdownIndicator {...props}>
            {hasValue ? (
                <FaCog
                    onClick={(e) => {
                        e.stopPropagation();
                        if (selectProps?.onConfigClick) {
                            selectProps.onConfigClick();
                        }
                    }}
                    title="Configurar departamento"
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                />
            ) : (
                <FaChevronDown style={{ color: "#999" }} />
            )}
        </components.DropdownIndicator>
    );
};

export default CustomDropdownIndicator;
